(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["index-everyday-life"] && !Shopify.designMode) return;
  try {
    
class EverydayLifeSection extends HTMLElement {
  connectedCallback() {
    this._tabs = this.querySelectorAll('.everyday-life__tab');
    this._panels = this.querySelectorAll('.everyday-life__panel');

    this._tabs.forEach((tab) => {
      tab.addEventListener('click', this._handleTabClick.bind(this));
    });

    this.querySelectorAll('.everyday-life__arrow').forEach((arrow) => {
      arrow.addEventListener('click', this._handleArrowClick.bind(this));
    });

    this.addEventListener('click', this._handleSwatchClick.bind(this));

    this._updateAllArrows();

    if (typeof ResizeObserver !== 'undefined') {
      this._resizeObserver = new ResizeObserver(() => this._updateAllArrows());
      this._resizeObserver.observe(this);
    }
  }

  disconnectedCallback() {
    if (this._resizeObserver) this._resizeObserver.disconnect();
  }

  _handleTabClick(event) {
    const clickedTab = event.currentTarget;
    const tabIndex = clickedTab.dataset.tabIndex;

    this._tabs.forEach((tab) => {
      const isActive = tab.dataset.tabIndex === tabIndex;
      tab.classList.toggle('everyday-life__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
    });

    this._panels.forEach((panel) => {
      const isActive = panel.dataset.panelIndex === tabIndex;
      panel.classList.toggle('everyday-life__panel--active', isActive);
      panel.hidden = !isActive;
      if (isActive) {
        const track = panel.querySelector('.everyday-life__carousel-track');
        if (track) {
          track.style.transform = 'translateX(0)';
          track.dataset.page = '0';
        }
        this._updateArrows(panel);
      }
    });
  }

  _handleArrowClick(event) {
    const arrow = event.currentTarget;
    const panel = arrow.closest('.everyday-life__panel');
    const track = panel.querySelector('.everyday-life__carousel-track');
    const viewport = panel.querySelector('.everyday-life__carousel-viewport');
    if (!track || !viewport) return;

    const cards = track.querySelectorAll(':scope > .shopify-block');
    if (cards.length <= 4) return;

    const currentPage = parseInt(track.dataset.page || '0', 10);
    const totalPages = Math.max(0, Math.ceil(cards.length / 4) - 1);
    const direction = arrow.dataset.direction;

    let newPage = currentPage;
    if (direction === 'next' && currentPage < totalPages) newPage = currentPage + 1;
    else if (direction === 'prev' && currentPage > 0)     newPage = currentPage - 1;
    if (newPage === currentPage) return;

    const viewportWidth = viewport.offsetWidth;
    const gap = 30;
    const cardWidth = (viewportWidth - 3 * gap) / 4;
    const pageStep = 4 * cardWidth + 4 * gap;
    const maxOffset = Math.max(0, track.scrollWidth - viewportWidth);
    const offset = Math.min(newPage * pageStep, maxOffset);

    track.style.transform = `translateX(-${offset}px)`;
    track.dataset.page = String(newPage);
    this._updateArrows(panel);
  }

  _handleSwatchClick(event) {
    const swatch = event.target.closest('.everyday-card-swatches__swatch');
    if (!swatch) return;

    const card = swatch.closest('[role="listitem"]') || swatch.closest('.shopify-block');
    if (!card) return;

    const imageUrl = swatch.dataset.variantImage;

    card.querySelectorAll('.everyday-card-swatches__swatch').forEach((s) => {
      s.classList.remove('everyday-card-swatches__swatch--active');
    });
    swatch.classList.add('everyday-card-swatches__swatch--active');

    if (!imageUrl) return;
    const img = card.querySelector('[class^="everyday-card-image-"] img');
    if (!img) return;

    const picture = img.closest('picture');

    const preload = new Image();
    preload.onload = () => {
      if (picture) {
        picture.querySelectorAll('source').forEach((source) => {
          source.removeAttribute('srcset');
        });
      }
      img.src = imageUrl;
      img.srcset = '';
      img.sizes = '';
      img.style.opacity = '1';
    };
    preload.onerror = () => { img.style.opacity = '1'; };
    img.style.opacity = '0.6';
    preload.src = imageUrl;
  }

  _updateArrows(panel) {
    const track = panel.querySelector('.everyday-life__carousel-track');
    const cards = track ? track.querySelectorAll(':scope > .shopify-block') : [];
    const currentPage = parseInt(track?.dataset.page || '0', 10);
    const totalPages = Math.max(0, Math.ceil(cards.length / 4) - 1);

    const prevBtn = panel.querySelector('.everyday-life__arrow--prev');
    const nextBtn = panel.querySelector('.everyday-life__arrow--next');
    const hasOverflow = cards.length > 4;
    if (prevBtn) prevBtn.disabled = !hasOverflow || currentPage <= 0;
    if (nextBtn) nextBtn.disabled = !hasOverflow || currentPage >= totalPages;
  }

  _updateAllArrows() {
    this._panels.forEach((panel) => {
      if (panel.classList.contains('everyday-life__panel--active')) {
        this._updateArrows(panel);
      }
    });
  }
}

if (!customElements.get('everyday-life-section')) {
  customElements.define('everyday-life-section', EverydayLifeSection);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
